import urls from './net-urls'
import axios from 'axios'

const HttpData = {
  ctx: null,
  init: function (ctx) {
    this.ctx = ctx
  },
  //获取微信分享标题内容
  wechatShare: function(obj,dataCB, errCB){

    this.httpGet(urls.phpcenter + "/shorturl/wechatshare/",obj,dataCB,errCB);
  },
  //邀请绑定
  inviteBind:function(obj,dataCB,errCB){
  
    let self = this
    if (obj == null) {
      obj = {}
    }
    var url = urls.ucenter + "/pre"
    axios.post(url, null, {params: obj, timeout: 1000 * 15}).then(function (result) {
      let data = result.data;
      dataCB(data);
    }).catch(function (err) {
      self.doError(err, errCB, 'post  ' + url)
    })
  },
  earningsRecord: function(obj,dataCB,errCB){

    this.httpPost(urls.phpcenter + "/spread/earningsrecord",obj,dataCB,errCB);
  },
  //分享通知
  shareBtn:function(obj,dataCB,errCB){

    this.httpPost(urls.phpcenter + "/spread/sharenotic",obj,dataCB,errCB);
  },
  //转轮抽奖
  reel:function(obj,dataCB,errCB){

    this.httpPost(urls.phpcenter + "/spread/reel",obj,dataCB,errCB);
  },
  //分享二维码
  getQrcode: function(obj,dataCB,errCB){

    this.httpPost(urls.phpcenter + "/spread/getqrcode",obj,dataCB,errCB);
  },
  //邀请收益
  inviteEarnings: function(obj,dataCB,errCB){

    this.httpPost(urls.phpcenter + "/spread/inviteearnings",obj,dataCB,errCB);
  },
  //获取推广虚拟数据
  getVirtual: function(obj,dataCB, errCB){

    this.httpGet(urls.phpcenter + "/spread/getvirtual/",obj,dataCB,errCB);
  },
  //推广信息
  spreadInfo: function(obj,dataCB,errCB){

    this.httpPost(urls.phpcenter + "/spread/spreadinfo",obj,dataCB,errCB);
  },
  //邀请记录
  spreadRecord: function(obj,dataCB,errCB){

    this.httpPost(urls.phpcenter + "/spread/spreadrecord",obj,dataCB,errCB);
  },
  //去除额外头的请求
  httpPost : function(url,obj,dataCB,errCB){
    let self = this
    if (obj == null) {
      obj = {}
    }
    axios.post(url, obj).then(function (result) {
      let data = result.data;
      dataCB(data);
    }).catch(function (err) {
      //self.doError(err, errCB, 'post  ' + url)
    });
  },
  httpGet(url, obj, dataCB, errCB) {
    let self = this
    if (obj == null) {
      obj = {}
    }
    axios.get(url, {params: obj}).then(function (result) {
      let data = result.data;
      dataCB(data);
    }).catch(function (err) {
      //self.doError(err, errCB, 'get  ' + url)
    })
  },
  //获取图片完整路径
  buildImgUrl: function (path, def) {
    if(path!= null && path.indexOf("http") != -1){
      return path
    }

    //本地图片
    if(path!=null && path.indexOf("group") == -1){
      if(def){
        return def
      }else{
        return './static/icon-def.png'
      }
    }

    let _url = ''
    if (path != null && path.length > 0) {
      _url =  urls.imgload + path
    } else {
      if (def) {
        _url = def
      } else {
        _url = './static/icon-def.png'
      }
    }
    // this.ctx.$logger.log(' buildImgUrl ', _url)
    return _url;
  },

  /* //百度经纬度返回；
   baidu: function ( dataCB, errCB) {
	 this.dogets('http://api.map.baidu.com/place/v2/search?query=ATM机&tag=银行&region=北京&output=json&ak=0et77GK7oCkOtltUQm17LwhLeLGOgxY3', null, dataCB, errCB)
   },*/
  //游客登录
  loginGuest: function (dataCB, errCB) {
    let obj = {};
    obj.deviceCode = this.ctx.$device.deviceCode
    obj.deviceType = this.ctx.$device.deviceType
    obj.deviceInfo = this.ctx.$device.deviceInfo
    this.doPost(urls.ucenter + "/visitor", obj, dataCB, errCB);
  },
  //免密码登录
  loginToken: function (aid, token, dataCB, errCB) {
    let obj = {};
    obj.id = aid;
    obj.soaToken = token;
    obj.deviceCode = this.ctx.$device.deviceCode
    obj.deviceType = this.ctx.$device.deviceType
    obj.deviceInfo = this.ctx.$device.deviceInfo
    this.doPost(urls.ucenter + "/login", obj, dataCB, errCB);
  },
  //手机号登录
  loginPhone: function (phone, pwd, dataCB, errCB) {
    let obj = {phone: phone, password: pwd}
    obj.deviceCode = this.ctx.$device.deviceCode
    obj.deviceType = this.ctx.$device.deviceType
    obj.deviceInfo = this.ctx.$device.deviceInfo
    this.doPost(urls.ucenter + "/login", obj, dataCB, errCB)

  },

  loginAppWechat(code, dataCB, errCB){
    let obj = {}
    obj.deviceCode = this.ctx.$device.deviceCode
    obj.deviceType = this.ctx.$device.deviceType
    obj.deviceInfo = this.ctx.$device.deviceInfo

    obj.code = code;
    this.doGet(urls.ucenter + "/wexin/app/login", obj, dataCB, errCB)
  },

  bindPhone(phone, sms, dataCB, errCB){
    let obj = {phone: phone, smsCode: sms}
    this.doPut(urls.ucenter + "/phone", obj, dataCB, errCB)
  },

  logout: function (dataCB, errCB) {
    this.doPost(urls.ucenter + "/logout", {}, dataCB, errCB);
  },

  wechat_ticket_get: function (obj, dataCB, errCB) {
    this.doGet(urls.ucenter + "/wexin/mp/ticket", obj, dataCB, errCB)
  },

//获取图片验证码(data.imgBase64)
  valid_image_get: function (dataCB, errCB) {
    this.doGet(urls.ucenter + "/valid/click_img", null, dataCB, errCB)
  },

//验证图片验证码(point {x:100, y:100})
  valid_image_valid: function (x1, y1, x2, y2, dataCB, errCB) {
    let icode = x1 + ":" + y1 + "," + x2 + ":" + y2
    let obj = {
      icode: icode
    };
    this.doPost(urls.ucenter + "/valid/click_img", obj, dataCB, errCB)
  },

//注册 - 获取短信验证码sms
  valid_sms_get: function (phone, dataCB, errCB) {
    let obj = {phone: phone};
    this.doGet(urls.ucenter + "/valid/sms", obj, dataCB, errCB)
  },

//注册 - 验证短信验证码sms
  valid_sms_valid: function (phone, smsCode, password, dataCB, errCB) {
    let obj = {};
    obj.phone = phone;
    obj.smsCode = smsCode;
    obj.password = password;
    this.doPost(urls.ucenter + "/valid/sms", obj, dataCB, errCB)
  },


//个人信息获取
  infoGet: function (dataCB, errCB) {
    this.doGet(urls.ucenter + "/info", null, dataCB, errCB)
  },

//获取别人的信息
  getOthersInfo(id, dataCB, errCB){
    this.doGet(urls.ucenter+'/search/info', {id:id}, dataCB, errCB)
  },

//个人信息修改
   infoModify: function (obj, dataCB, errCB) {
    let header = this.getHeader()
    header['Content-Type'] = 'application/json';
    this.doPut(urls.ucenter + "/info", obj, dataCB, errCB, header)
  },
  //我的密码修改
  passwd_update: function (password, oldPwd, dataCB, errCB) {
    let obj = {password: password, oldPwd: oldPwd};
    this.doPut(urls.ucenter + "/passwd", obj, dataCB, errCB);
  },

//支付宝账号添加
  cards_add: function (dataCB, errCB) {

  },
//支付宝账号更新
  cards_update: function (dataCB, errCB) {

  },
//支付宝账号删除
  cards_delete: function (dataCB, errCB) {

  },
//支付宝账号获取
  cards_get: function (dataCB, errCB) {

  },
//爱好信息获取
  hobby_get: function (dataCB, errCB) {
    this.doGet(urls.ucenter + "/hobby", null, dataCB, errCB)
  },
//游客信息获取
  guest_info_get: function (dataCB, errCB) {
    this.doGet(urls.ucenter + "/visitor/info", null, dataCB, errCB)
  },

  register_check: function (dataCB, errCB) {
    this.doGet(urls.ucenter + "/valid/register", null, dataCB, errCB)
  },
//密码(忘记 - 重置) 获取图片验证码(data.imgBase64)
  password_image_get: function (dataCB, errCB) {
    this.doGet(urls.ucenter + "/passwd/click_img", null, dataCB, errCB)
  },

//密码(忘记 - 重置)验证图片验证码(point {x:100, y:100})
  password_image_valid: function (x1, y1, x2, y2, dataCB, errCB) {
    let icode = x1 + ":" + y1 + "," + x2 + ":" + y2
    let obj = {
      icode: icode
    };
    this.doPost(urls.ucenter + "/passwd/click_img", obj, dataCB, errCB)
  },
//密码(忘记 - 重置) - 获取短信验证码sms
  password_sms_get: function (phone, dataCB, errCB) {
    let obj = {phone: phone};
    this.doGet(urls.ucenter + "/passwd/sms", obj, dataCB, errCB)
  },

//密码(忘记 - 重置) - 验证短信验证码sms
  password_sms_valid: function (phone, smsCode, password, dataCB, errCB) {
    let obj = {};
    obj.deviceCode = this.ctx.$device.deviceCode
    obj.phone = phone;
    obj.smsCode = smsCode;
    obj.password = password;
    this.doPut(urls.ucenter + "/passwd/reset", obj, dataCB, errCB)
  },
//用户搜索
  userSearch(obj,dataCB,errCB){
    this.doGet(urls.ucenter+'/search/info',obj,dataCB,errCB)
  },
//访问者发布信息
  UserPublish(obj,dataCB,errCB){
    this.doGet(urls.ucenter+'/search/publish',obj,dataCB,errCB)
  },
//玩家搜索
  friendSearch: function (uid, dataCB, errCB) {
    this.doGet(urls.social + "/search/" + uid, null, dataCB, errCB)
  },

  // 添加对方为好友
  friendAdd: function (obj, dataCB, errCB) {
    this.doPost(urls.social + "/friend/", obj, dataCB, errCB)
  },

  // 删除对方为好友
  friendDel: function (id, dataCB, errCB) {
    this.doDelete(urls.social + "/friend/" + id, null, dataCB, errCB)
  },

//好友申请列表
  friendReqGet: function () {
    this.doGet(urls.social + "/friend/ask", null, dataCB, errCB)
  },
//好友申请回复同意
  friendReqAgree: function (obj, dataCB, errCB) {
    this.doPost(urls.social + "/ask/agree", obj, dataCB, errCB)
  },
  //好友申请回复拒绝
  friendReqRefuse: function (obj, dataCB, errCB) {
    this.doPost(urls.social + "/ask/refuse", obj, dataCB, errCB)
  },

//好友列表获取
  friendListGet: function (dataCB, errCB) {
    this.doGet(urls.social + "/friend", null, dataCB, errCB)
  },

  //黑名单列表获取
  refuseListGet: function (dataCB, errCB) {
    this.doGet(urls.social + "/rejecter", null, dataCB, errCB)
  },

  //好友Ack
  friendAck: function (id) {
    this.doPost(urls.social + "/ack", {msgId: id}, null, null)
  },

  //接单/加入群聊
  groupJoin: function (id, dataCB, errCB) {
    this.doPost(urls.social + "/group/join", {id: id}, dataCB, errCB)
  },



//文件服务
  img_upload: function (file, dataCB, errCB) {
    let obj = {file: file}
    this.doMultipart(urls.fupload + '/img', obj, dataCB, errCB)
  },
  //实名认证
  realname: function (id, name, front, back, dataCB, errCB) {
    let obj = {id: id, name: name, front: front, back: back}
    this.doMultipart(urls.ucenter + '/valid/idcard', obj, dataCB, errCB)
  },
  //获取修改图片验证码(data.imgBase64)
  phone_image_get: function (dataCB, errCB) {
    this.doGet(urls.ucenter + "/change", null, dataCB, errCB)
  },
  //修改手机号图片验证码校验(point {x:100, y:100})
  phone_imgcode: function (x1, y1, x2, y2, dataCB, errCB) {
    let icode = x1 + ":" + y1 + "," + x2 + ":" + y2
    let obj = {
      icode: icode
    };
    this.doPost(urls.ucenter + "/change", obj, dataCB, errCB)
  },
  //修改手机号-获取短信验证码sms
  get_phone_code: function (dataCB, errCB) {
    this.doGet(urls.ucenter + "/change/sms", null, dataCB, errCB)
  },
  //修改手机号码
  //注册 - 验证短信验证码sms
  amentphone: function (smsCode, password, dataCB, errCB) {
    let obj = {};
    obj.sms = smsCode;
    obj.phone = password;
    this.doPut(urls.ucenter + "/change/phone", obj, dataCB, errCB)
  },
  /* amentphone: function (obj, dataCB, errCB) {
	 let header = this.getHeader()
	 header['Content-Type'] = 'application/json';
	 this.doPut(urls.ucenter + "/info", obj, dataCB, errCB, header)
   },*/
  //红包服务
  rpWelcomeGet(dataCB, errCB) {
    this.doGet(urls.rpacket + "/visitor/first", null, dataCB, errCB)
  },

  rpWelcomeReward(obj, dataCB, errCB) {
    this.doPost(urls.rpacket + "/visitor/first", obj, dataCB, errCB)
  },
  //主页 一公里红包
  locRedPacketDataGet(obj, dataCB, errCB) {
    this.doGet(urls.rpacket + "/visitor/packet", obj, dataCB, errCB)
  },

  rpLocationReward(obj, dataCB, errCB) {
    this.doPost(urls.rpacket + "/take", obj, dataCB, errCB)
  },

  rpLocationDetail(id, dataCB, errCB) {
    this.doGet(urls.rpacket + "/" + id, null, dataCB, errCB)
  },
  rpPublish(obj, dataCB, errCB) {
    this.doPost(urls.rpacket, obj, dataCB, errCB)
  },

  rpPrePublish(obj, dataCB, errCB) {
    this.doPost(urls.rpacket + '/pre', obj, dataCB, errCB)
  },

  rpLikeItem(obj, dataCB, errCB) {
    this.doPut(urls.rpacket, obj, dataCB, errCB)
  },

  rpHistory(obj, dataCB, errCB) {
    this.doGet(urls.rpacket + '/history', obj, dataCB, errCB)
  },

  rpConfig(dataCB, errCB) {
    this.doGet(urls.rpacket + '/config', null, dataCB, errCB)
  },
  //红包详情
  rppackgeDetail(id,dataCB,errCB){
    this.doGet(urls.rpacket+'/' + id, null, dataCB, errCB)
  },
  //红包评论
  rppackgeComment(obj,dataCB,errCB){
    this.doPost(urls.rpacket+'/comment',obj,dataCB,errCB)
  },
  //获取红包评论列表
  rpGetcomment(obj,dataCB,errCB){
    this.doGet(urls.rpacket+'/comment',obj,dataCB,errCB)
  },
  //红包预估
  rppackgeEstimate(id,dataCB,errCB){
    this.doGet(urls.rpacket+'/pre/'+id,null,dataCB,errCB)
  },
  //红包点赞
  rppackgeUpvote(obj,dataCB,errCB){
    this.doPost(urls.rpacket+'/like',obj,dataCB,errCB)
  },
  //订单发布
  rpOrderPublish(obj, dataCB, errCB) {
    this.doMultipart(urls.ocenter + '/paid', obj, dataCB, errCB)
  },
  //订单点赞
  OrderUpvote(obj, dataCB, errCB){
    this.doPost(urls.ocenter + '/like',obj, dataCB, errCB)
  },
  //订单评论
  OrderComment(obj,dataCB,errCB){
    this.doPost(urls.ocenter+'comment',obj,dataCB,errCB)
  },
  // 获取评论内容
  OrdergetComment(obj,dataCB,errCB){
    this.doGet(urls.ocenter+'comment',obj,dataCB,errCB)
  },
  //获取接单用户
  OrderTakinguser(id,dataCB,errCB){
    this.doGet(urls.ocenter+'/executor/'+id,null,dataCB,errCB)
  },
  //发布话题
  rpTopicPublish(obj, dataCB, errCB){
    this.doMultipart(urls.ocenter + '/free', obj, dataCB, errCB)
  },
  // 主页 一公里话题
  locTopicDataGet(obj, dataCB, errCB) {
    this.doGet(urls.ocenter + "/free", obj, dataCB, errCB)
  },
  // 获取话题
  topicDetailGet(id,dataCB,errCB){
    this.doGet(urls.ocenter + "/free/" + id , null, dataCB, errCB)
  },
  //主页 一公里订单
  locOrderDataGet(obj, dataCB, errCB) {
    this.doGet(urls.ocenter + "/paid", obj, dataCB, errCB)
  },

  //订单详情
  orderDetailGet(id, dataCB, errCB) {
    this.doGet(urls.ocenter + "/paid/" + id , null, dataCB, errCB)
  },
  // 接单
  TakesOreder(obj, dataCB, errCB){
    this.doPost(urls.ocenter+"/paid/take",obj,dataCB,errCB)
  },

  //发布的历史订单
  orderPublishHistory(obj, dataCB, errCB){
    this.doGet(urls.ocenter+"/history/demand",obj,dataCB,errCB)
  },

  // 我的订单 - 发布需求 - 历史订单 - 详情
  orderPublishDetail(id, dataCB, errCB){
    this.doGet(urls.ocenter + "/history/demand/" + id, null, dataCB, errCB)
  },

  // 我的订单 - 发布需求 - 放弃需求
  orderPublishCancel(id, dataCB, errCB){
    this.doPut(urls.ocenter + "/paid/cancel/" + id, null, dataCB, errCB)
  },

  //领取的历史订单
  orderRewardHistory(obj, dataCB, errCB){
    this.doGet(urls.ocenter+"/history/task",obj,dataCB,errCB)
  },

  walletCash(obj, dataCB, errCB) {
    this.doPost(urls.payment + '/cash', obj, dataCB, errCB)
  },

  walletRecord(dataCB, errCB) {
    this.doGet(urls.payment + '/cash', null, dataCB, errCB)
  },

  charge(url, obj, dataCB, errCB) {
    this.doPost(urls.payment + url, obj, dataCB, errCB)
  },

  //魔圈列表, 所有
  moCircleGetAll(lastId, dataCB, errCB){
    let obj = null;
    if(lastId){
      obj = {lastId: lastId}
    }
    this.doGet(urls.ocenter + '/disconver', obj, dataCB, errCB)
  },

  //魔圈列表, 附近
  moCircleGetNearby(obj, dataCB, errCB){
    this.doGet(urls.ocenter + '/disconver/nearby', obj, dataCB, errCB)
  },

  wxin_config_get(url, obj, dataCB, errCB){
    this.doGet(url, obj, dataCB, errCB)
  },

  //签到
  sign(dataCB, errCB){
    this.doPost(urls.mission + '/sign', dataCB, errCB)
  },
  //获取签到信息
  signInfo(headers,dataCB, errCB){
    // this.doGet(urls.mission + '/sign', null, dataCB, errCB)
    this.doHeadersGet(urls.mission + '/sign',headers, dataCB, errCB)
  },
  //获取日活跃和周信息
  activityInfo(headers,dataCB, errCB){
    // this.doGet(urls.mission + '/active/day', null, dataCB, errCB)
    this.doHeadersGet(urls.mission + '/active/info',headers, dataCB, errCB);
  },
  //获取每日任务信息
  dayTaskInfo(headers,dataCB, errCB){
    // this.doGet(urls.mission + '/mission/day', null, dataCB, errCB)
    this.doHeadersGet(urls.mission + '/mission/day',headers,dataCB, errCB);
  },
  //获取永久任务信息
  foreverTask(headers,dataCB, errCB){
    this.doHeadersGet(urls.mission + '/mission/long',headers,dataCB, errCB);
  },
  //领取周活跃宝箱
  receiveWeekTreasure(headers,obj,dataCB, errCB){
    this.doHeadersPost(urls.mission + '/active/week',headers,obj,dataCB, errCB);
  },
  //领取日活跃宝箱
  receiveDayTreasure(headers,obj,dataCB, errCB){
    this.doHeadersPost(urls.mission + '/active/day',headers,obj,dataCB, errCB);
  },
  doHeadersGet(url,headers,dataCB,errCB){
    axios.get(url, {headers: headers, timeout: 1000 * 15}).then(function (result) {
      if(result.data.errCode==0){
        if(dataCB!=null){
          dataCB(result.data.data);
        }
      }else{
        if(errCB!=null){
          errCB(result.data);
        }
      }
    }).catch(function (err) {
      if(errCB!=null){
        errCB(err);
      }
    })
  },
  doHeadersPost(url,headers,obj,dataCB,errCB){
    axios.post(url, null, {params: obj, headers: headers, timeout: 1000 * 15}).then(function (result) {
      if(result.data.errCode==0){
        if(dataCB!=null){
          dataCB(result.data.data);
        }
      }else{
        if(errCB!=null){
          errCB(result.data);
        }
      }
    }).catch(function (err) {
      if(errCB!=null){
        errCB(err);
      }
    })
  },

  doPost(url, obj, dataCB, errCB) {
    let self = this
    if (obj == null) {
      obj = {}
    }
    this.ctx.$logger.log("post  " + url + " :" + JSON.stringify(obj));

    axios.post(url, null, {params: obj, headers: this.getHeader(), timeout: 1000 * 15}).then(function (result) {
      self.doThen(result, dataCB, errCB, url)
    }).catch(function (err) {
      self.doError(err, errCB, 'post  ' + url)
    })
  },

  doMultipart(url, obj, dataCB, errCB){
    let self = this
    if (obj == null) {
      obj = {}
    }
    this.ctx.$logger.log("multipart post  " + url + " :" + JSON.stringify(obj));
    let header = this.getHeader()
    header['Content-Type'] = 'multipart/form-data'
    let param = new FormData()

    Object.keys(obj).forEach(function(key){
      if(obj[key].push){
        for (const item of obj[key]){
          if(item.name){
            param.append(key, item, item.name)
          }else{
            param.append(key, item)
          }
        }
      }else{
        param.append(key, obj[key])
      }

    });

    axios.post(url, param, {headers: header, timeout: 1000 * 20}).then(function (result) {
      self.doThen(result, dataCB, errCB, url)
    }).catch(function (err) {
      self.doError(err, errCB, 'multipart post' + url)
    })
  },


  doGet(url, obj, dataCB, errCB) {
    let self = this
    if (obj == null) {
      obj = {}
    }
    this.ctx.$logger.log("get  " + url + " :" + JSON.stringify(obj));
    axios.get(url, {params: obj, headers: this.getHeader(), timeout: 1000 * 15}).then(function (result) {
      self.doThen(result, dataCB, errCB, url)
    }).catch(function (err) {
      self.doError(err, errCB, 'get  ' + url)
    })
  },
  doPut(url, obj, dataCB, errCB, header) {
    let self = this
    if (obj == null) {
      obj = {}
    }
    if (header == null) {
      header = this.getHeader()
      header['Content-Type'] = 'application/json';
    }
    this.ctx.$logger.log("put  " + url + " :" + JSON.stringify(obj));
    axios.put(url, obj, {headers: header, timeout: 1000 * 15}).then(function (result) {
      self.doThen(result, dataCB, errCB, url)
    }).catch(function (err) {
      self.doError(err, errCB, 'put  ' + url)
    })
  },

  doDelete(url, obj, dataCB, errCB) {
    let self = this
    if (obj == null) {
      obj = {}
    }
    this.ctx.$logger.log("delete  " + url + " :" + JSON.stringify(obj));
    axios.delete(url, {params: obj, headers: this.getHeader()}).then(function (result) {
      self.doThen(result, dataCB, errCB, url)
    }).catch(function (err) {
      self.doError(err, errCB, 'delete ' + url)
    })
  },

  doThen(result, dataCB, errCB, url) {
    let data = result.data;
    this.ctx.$logger.log("result: " + url + '   ' + JSON.stringify(data))

    if (data.hasOwnProperty("errCode")) {
      let errCode = data.errCode
      if (errCode == 0) {
        if (dataCB != null) {
          try {
            dataCB(data.data)
          } catch (e) {
            this.ctx.$logger.error(e)
          }
        }
      } else {
        if(data.errCode == 3004){//设备码不存在
          let obj = {}
          this.ctx.$preference.saveOwnInfo(obj)
          this.ctx.$preference.saveLastLoginType('')
          this.ctx.$info.logout()
          this.ctx.$login_data.tokenLogin()
        }else if(data.errCode == 3005){//非游客跳登录
          this.ctx.$nav_util.naveToLogin()

          this.toastErrorMsg({errMsg: '请重新登录'})
        }else if (this.needReLogin(data)) {
          this.ctx.$nav_util.naveToLogin()

          this.toastErrorMsg({errMsg: '请重新登录'})
        }else{
          if(data.errCode == 3006){//跳绑定手机
            this.ctx.$nav_util.goBindPhone()
          }else if(data.errCode == 3007){//跳实名认证
            this.ctx.$nav_util.goBindRealName()
          }else{
            if (errCB != null) {
              try {
                errCB(data);
                return;
              } catch (e) {
                this.ctx.$logger.error(e)
              }
            }
          }
          this.toastErrorMsg(data)
        }
      }
    }
  },

  toastErrorMsg(data){
    let msg = data.errMsg
    if (msg != null && msg != '') {
      this.ctx.$store.commit('showToastNormal', msg)
    }
  },

  needReLogin(data){
    let errCode = data.errCode
    return errCode == 2001 || errCode == 4003 || errCode == 3003 || errCode == 3005
  },

  doError(err, errCB, url) {
    this.ctx.$logger.error(url, '  网络错误')
    if (errCB != null) {
      errCB({errMsg: '网络错误,请稍后重试'});
    } else {
      this.ctx.$store.commit('showToastNormal', '网络错误,请稍后重试')
    }
  },

  getHeader() {
    let header = {}
    header['aid'] = this.ctx.$info.id
    header['soa-token'] = this.ctx.$info.soaToken
    header['deviceCode'] = this.ctx.$device.deviceCode

    header['Content-Type'] = 'application/x-www-form-urlencoded';

    this.ctx.$logger.log('header ', JSON.stringify(header))
    return header;
  }
}

HttpData.install = function (Vue, options) {
  Vue.prototype.$http_data = HttpData
}

export default HttpData;



// WEBPACK FOOTER //
// ./src/plugins/net-http.js